import React from 'react';
import { ZCDTable } from '@zencity/common-ui';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const OverAllTable = (props) => {
  const { overAllSentimentCounts } = props;
  const { t } = useTranslation();

  const total = Object.values(overAllSentimentCounts).reduce((acc, count) => acc + count, 0);

  const columnArray = [
    { Header: '', accessor: 'label' },
    { Header: t('pinDrop.count'), accessor: 'count' },
    { Header: '%', accessor: 'percentage' },
  ];

  const tableData = [
    {
      label: 'Total',
      count: total,
      percentage: '100%',
    },
  ];

  return <ZCDTable columnArray={columnArray} tableData={tableData} />;
};

OverAllTable.propTypes = {
  overAllSentimentCounts: PropTypes.shape({}).isRequired,
};

export default OverAllTable;
